
import { useState } from "react";
import { Store, StoreDifferences } from '../../../types';
import StoreCardHeader from './StoreCardHeader';
import StoreCardSyncArea from "./StoreCardSyncArea";
import StoreCardDifferences from "./StoreCardDifferences";
import { IconButton } from "@mui/material";
import EditIconNew from "../../../assets/EditIconNew";
import { useNavigate } from "react-router-dom";

type Props =
    {
        store: Store,
        sync: (store: Store) => any,
        productDifferences: StoreDifferences | null,
        collectionDifferences: StoreDifferences | null
    }

export default function StoreCardContainer({ store, sync, productDifferences, collectionDifferences }: Props) {
    const [error, setError] = useState<undefined | string>();
    const [enabled, setEnabled] = useState(store.enabled);

    const navigate = useNavigate();

    const syncStore: () => Promise<void> = async () => {
        const error = await sync(store);
        const msg =
            error == null || (typeof error === "string" && error.trim() === "")
                ? ""
                : (typeof error === "string" ? error : (error as any)?.message) ?? JSON.stringify(error);

        setError(msg);
    }

    const manageStore = () => {
        navigate(`/management/${store.id}`, { replace: true });
    }

    return (
        <div className="store-date">
            <div className="info-stores-container-top">
                <div className="management-div">
                    <IconButton
                        aria-label="more"
                        onClick={manageStore}
                        aria-haspopup="true"
                        aria-controls="long-menu"
                    >
                        <EditIconNew></EditIconNew>
                    </IconButton>
                </div>
                <StoreCardHeader store={store} enabled={enabled} setEnabled={setEnabled} onManage={manageStore} key={store.id}></StoreCardHeader>
                <StoreCardSyncArea store={store} enabled={enabled} error={error} syncStore={syncStore}></StoreCardSyncArea>
                <StoreCardDifferences store={store} productDifferences={productDifferences} collectionDifferences={collectionDifferences} enabled={enabled}></StoreCardDifferences>
            </div>
        </div>
    )
}